import type { CSSProperties, ImgHTMLAttributes } from "react";

type StaticImageData = Readonly<{
	readonly src: string;
	readonly width?: number;
	readonly height?: number;
}>;

export interface ImageProps
	extends Omit<ImgHTMLAttributes<HTMLImageElement>, "src" | "width" | "height"> {
	readonly src: string | StaticImageData;
	readonly width?: number | `${number}`;
	readonly height?: number | `${number}`;
	readonly fill?: boolean;
	readonly priority?: boolean;
	readonly unoptimized?: boolean;
	readonly sizes?: string;
}

export function staticAssetPath(source: string): string {
	return source.startsWith("/") && !source.startsWith("//")
		? `${import.meta.env.BASE_URL}${source.slice(1)}`
		: source;
}

export default function Image({
	alt,
	src,
	fill = false,
	priority = false,
	unoptimized: _unoptimized,
	style,
	width,
	height,
	...props
}: ImageProps) {
	const source = typeof src === "string" ? src : src.src;
	const resolvedSource = staticAssetPath(source);
	const resolvedStyle: CSSProperties | undefined = fill
		? {
				position: "absolute",
				inset: 0,
				width: "100%",
				height: "100%",
				...style,
			}
		: style;
	return (
		<img
			{...props}
			alt={alt}
			src={resolvedSource}
			width={fill ? undefined : width}
			height={fill ? undefined : height}
			style={resolvedStyle}
			loading={priority ? "eager" : props.loading}
			fetchPriority={priority ? "high" : props.fetchPriority}
		/>
	);
}
